import script from "./checkbox-list.vue?vue&type=script&setup=true&lang=js"
export * from "./checkbox-list.vue?vue&type=script&setup=true&lang=js"

import "./checkbox-list.vue?vue&type=style&index=0&id=761727ba&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761727ba"]])

export default __exports__